import { render, staticRenderFns } from "./move-campus-modal.vue?vue&type=template&id=a67ce986&"
import script from "./move-campus-modal.vue?vue&type=script&lang=js&"
export * from "./move-campus-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports